export default __webpack_public_path__ + "static/circles_imageSection-b5cd6c4ae3665508dced5fa16b0029fa.svg";